module.exports = __webpack_public_path__ + "static/media/Рябов К..887dc70d.pdf";